"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _Dropdown = _interopRequireDefault(require("../../Dropdown/Dropdown"));

var _Button = _interopRequireDefault(require("../../Button/Button"));

var _icons = require("../../../assets/icons");

var _MenuItem = require("./MenuItem.styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MoreOptions = function MoreOptions(_ref) {
  var otherProps = (0, _extends2["default"])({}, _ref);
  // Prevent trigger menu item's click event
  var handleClick = (0, _react.useCallback)(function (e) {
    e.stopPropagation();
  }, []);
  return (0, _jsxRuntime.jsx)(_Dropdown["default"], _objectSpread(_objectSpread({
    position: "right-start",
    css: _MenuItem.styles.moreOptionsDropdown,
    autoHeight: true,
    strategy: "fixed",
    onClick: handleClick
  }, otherProps), {}, {
    children: (0, _jsxRuntime.jsx)(_Button["default"] // MenuItem is a button by default, can't use button inside a button
    , {
      as: "div",
      tabIndex: 0,
      role: "button",
      type: "icon",
      size: "small",
      css: _MenuItem.styles.optionsBtn,
      className: "menu-item-options",
      children: (0, _jsxRuntime.jsx)(_icons.OptionsHorizontal, {})
    })
  }));
};

var _default = MoreOptions;
exports["default"] = _default;
//# sourceMappingURL=MoreOptions.js.map